import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import SessionValidation from "../context/SessionValidationContext";
import { fetchToken } from "../services/fetchTokenService";
import { getConsumerKey } from "../services/maerskApiTokenService";

export const PutWithRetry = () => {
  const { instance, accounts } = useMsal();
  const { setSessionExpired } = SessionValidation();
  const putWithRetry = async (
    url,
    postmortemData,
    additionalHeaders = {},
    retries = 3,
    delay = 1000
  ) => {
    try {
      // Keep MSAL session validation
      const tokenResponse = await fetchToken(instance, loginRequest, accounts);
      if (tokenResponse && tokenResponse.sessionExpired) {
        sessionStorage.clear();
        setSessionExpired(true);
      }

      // Use Maersk API token (client-credentials) for API gateway auth
      // const apiToken = await getApiToken();

      const config = {
        headers: {
          Authorization: `Bearer ${tokenResponse.idToken}`,
          "consumer-key": getConsumerKey(),
          ...additionalHeaders, // Merge additional headers
        },
      };

      const response = await axios.request({
        ...config,
        method: "put",
        url: url,
        data: postmortemData,
      });
      if (response.status === 200 || response.status === 201 || response.status === 202) {
        return response;
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        let forgeRockErrorCode = error.response?.data?.errorcode;
        if(forgeRockErrorCode && forgeRockErrorCode === "steps.jwt.TokenExpired"){
          console.error(forgeRockErrorCode)
        }
        sessionStorage.clear();
        throw error;
      }

      if (retries === 0 || !(error.response && error.response.status === 401)) {
  
        console.error("error ", error)
        throw error;
      }

      await new Promise((res) => setTimeout(res, delay));
      return putWithRetry(url, postmortemData, retries - 1, delay * 2);
    }
  };

  return {
    putWithRetry,
  };
};
